import cn from 'classnames';

import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';

import { STATS } from './constants';
import { StatsItem } from './StatsItem';
import styles from './styles.module.scss';

export const StatsBlock = () => {
  const isMobile = useIsMobile();

  return (
    <Space justify="space-between" className={cn(styles.stats, { [styles.mobile]: isMobile })}>
      {STATS.map((item: (typeof STATS)[number]) => (
        <StatsItem key={item.id} {...item} />
      ))}
    </Space>
  );
};
